import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export const ROLE_LABELS = {
  client: "Client",
  peer_specialist: "Peer Support Specialist",
  facilitator: "Program Facilitator",
  coordinator: "Program Coordinator",
  court_officer: "Referral Source",
  referral_source: "Referral Source",
  admin: "Executive Director",
  network_admin: "Network Administrator",
  resource_partner: "Community Resource Partner",
  housing_coordinator: "Housing Coordinator",
  housing_staff: "Housing Staff",
  housing_resident: "Housing Resident"
};

export const ROLE_COLORS = {
  client: "bg-teal-100 text-teal-800",
  peer_specialist: "bg-sky-100 text-sky-800",
  facilitator: "bg-orange-100 text-orange-800",
  coordinator: "bg-amber-100 text-amber-800",
  court_officer: "bg-slate-100 text-slate-800",
  referral_source: "bg-slate-100 text-slate-800",
  admin: "bg-violet-100 text-violet-800",
  network_admin: "bg-indigo-100 text-indigo-800",
  resource_partner: "bg-emerald-100 text-emerald-800",
  housing_coordinator: "bg-cyan-100 text-cyan-800",
  housing_staff: "bg-teal-100 text-teal-800",
  housing_resident: "bg-cyan-50 text-cyan-800"
};

export function formatDate(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export function formatTime(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  return d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
}

export function timeAgo(dateStr) {
  if (!dateStr) return "";
  const now = new Date();
  const d = new Date(dateStr);
  const diff = Math.floor((now - d) / 1000);
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}
